import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';

export default function AdvanceSettings({ children, attributes, setAttributes }) {
	const [vAlign = '', hAlign = ''] = (attributes.boxalignment || '').split(' ');

	// Your custom interpretation:
	const justifyMap = {
		top: 'flex-start',
		center: 'center',
		bottom: 'flex-end',
	};

	const alignMap = {
		left: 'flex-start',
		center: 'center',
		right: 'flex-end',
	};

	const justifyContent = justifyMap[vAlign] || 'initial';
	const alignItems = alignMap[hAlign] || 'initial';

	const blockProps = useBlockProps({
		style: {
			'--align-matrix-items': alignItems,
			'--justify-matrix-content': justifyContent,
		},
	});

	if (attributes.classNamemain !== blockProps.className) {
		setAttributes({ classNamemain: blockProps.className });
	}

	return <div {...blockProps}>{children}</div>;
}
